import React from "react";
import style from "./index.module.scss";
import VoteItem from "./components/VoteItem";

interface VoteResultProps {
    data: {
        count: number;
        text: string;
    }[];
    total: number;
}

export default function VoteResult({ data, total }: VoteResultProps) {
    return (
        <div className={style.root}>
            <h1 className={style.title}>投票结果</h1>

            <div className={style.main}>
                {data.map(item => (
                    <VoteItem
                        key={item.text}
                        text={item.text}
                        count={item.count}
                        total={total}
                    />
                ))}
            </div>

            <div className={style.tip}>
                <span>投票人数</span>
                <span>课程人数</span>
            </div>
        </div>
    );
}
